export default __webpack_public_path__ + "static/media/reactivate.5fa65703.svg";